/**
 * 是否酒店商家App
 * @param ua
 * @returns
 */
export const isMHotel = (ua) => /mhotel/i.test(ua);
/**
 * 是否点评管家
 * @param ua
 * @returns
 */
export const isDianPingMerchant = (ua) => {
    if (ua.indexOf("com.dianping.merchant.mobile") > -1 ||
        ua.indexOf("com.dianping.mp.mobile") > -1) {
        return true;
    }
    return false;
};
/**
   * 是否门票商家App
   * @param ua
   * @returns
   */
export const isTripbiz = (ua) => {
    if (ua.indexOf('com.meituan.tripBiz') > -1
        || ua.indexOf('com.kuxun.tripBiz') > -1) {
        return true;
    }
    return false;
};
/**
 * 是否美团商家App（开店宝）
 * @param ua
 * @returns
 */
export const isMerchant = (ua) => {
    if (
    // 开店宝内测和正式版ua信息不一致。https://app.sankuai.com/app?page=1&keyword=%E5%BC%80%E5%BA%97%E5%AE%9D
    ua.indexOf("com.sankuai.meituan.merchant") > -1 ||
        ua.indexOf("com.meituan.imerchantbiz") > -1 // 开店宝正式版: com.meituan.imerchantbiz，内测版：com.meituan.imerchantbiz.ep
    ) {
        return true;
    }
    return false;
};
/**
 * 是否美团商家App（开店宝）
 * @param ua
 * @returns
 */
export const isKaiDianBao = isMerchant;
/**
* 是否为百川App
* @param ua
* @returns
*/
export const isBaiChuan = (ua) => {
    return ua.indexOf("com.sankuai.scsx.shuguopaiappstore") > -1 ||
        ua.indexOf("com.sankuai.scsx.android.shuguopai") > -1 ||
        /com\.sankuai\..*\.shuguopai/.test(ua);
};
/**
 * 是否外卖商家App
 * @param ua
 * @returns
 */
export const isWaiMaiMerchantApp = (ua) => /meituanwaimaibusiness/i.test(ua) || /meituanwaimai-b/i.test(ua);
/**
 * 是否为美团管家智能版
 * @param ua
 * @returns
 */
export const isErpBossPro = (ua) => {
    return ua.indexOf("com.sankuai.ngboss") > -1 ||
        ua.indexOf("com.meituan.erpbosspro") > -1;
};
